import { Link } from "react-router-dom";
import type { Category } from "@/mocks/categories";

interface CategoryNavProps {
  categories: Category[];
  activeSlug?: string;
}

export default function CategoryNav({ categories, activeSlug }: CategoryNavProps) {
  return (
    <section className="py-8 md:py-10">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-5 md:mb-6">浏览分类</h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => {
            const isActive = activeSlug === cat.slug;
            return (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`group flex flex-col items-center gap-2.5 p-4 md:p-5 rounded-xl cursor-pointer transition-all ${
                  isActive
                    ? "bg-primary-100/80 border-2 border-primary-300"
                    : "bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-background-100/70"
                }`}
              >
                <div
                  className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl transition-colors ${
                    isActive
                      ? "bg-primary-500 text-background-50"
                      : "bg-secondary-100 text-secondary-700 group-hover:bg-primary-100 group-hover:text-primary-600"
                  }`}
                >
                  <i className={`${cat.icon} text-xl md:text-2xl`}></i>
                </div>
                <span
                  className={`text-sm font-medium whitespace-nowrap transition-colors ${
                    isActive ? "text-primary-700" : "text-foreground-800"
                  }`}
                >
                  {cat.name}
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}